const queryProductsByHandle=handle=>JSON.stringify({query:`
    query($handle: String!) {
      product(handle: $handle) {
        id
        price: priceRange {
          minVariantPrice {
            amount
          }
        }
        compareAtPrice: compareAtPriceRange {
          minVariantPrice {
            amount
          }
        }
        variants(first: 100) {
          edges {
            node {
              title
              id
              price: price {
                amount
              }
              compareAtPrice: compareAtPrice {
                amount
              }
            }
          }
        }
      }
    }
  `,variables:{handle}});export default queryProductsByHandle;
//# sourceMappingURL=/s/files/1/0002/4680/8603/t/115/assets/queryProductsByHandle.js.map?v=1727707357
